import React, { useState } from 'react';
import { Modal, Form, FormControl, FormSelect, Button } from 'react-bootstrap';
import { client } from '../../api/client';
import RichTextEditor from '../policy/RichTextEditor';
import styles from './NotificationPage.module.scss';
import NotificationDetailModal from './NotificationDetailModal';

const NOTIFICATION_TYPES = ['Reminder', 'Urgent Update', 'Operation', 'Weekly Update'];

export default function CreateNotificationModal({ show, onClose, onCreated }) {
  const [title, setTitle] = useState('');
  const [type, setType] = useState(NOTIFICATION_TYPES[0]);
  const [message, setMessage] = useState('');
  const [creating, setCreating] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const SHOW_PREVIEW = (() => {
    const raw = process.env.REACT_APP_SHOW_NOTIFICATION_PREVIEW_ONCREATE;
    if (typeof raw === 'undefined' || raw === null) return false;
    const v = String(raw).toLowerCase().trim();
    return v === '1' || v === 'true' || v === 'yes';
  })();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (SHOW_PREVIEW) {
      // open preview modal before actual create
      setShowPreview(true);
    } else {
      // directly create without preview
      await handleConfirmCreate();
    }
  };

  const handleConfirmCreate = async () => {
    setCreating(true);
    try {
      const payload = { title, message, type };
      const res = await client.post('notifications/create', payload);
      if (res && res.success) {
        onCreated?.(res.data);
        setShowPreview(false);
        handleClose();
      }
    } catch (err) {
      // errors shown by client toast
    } finally {
      setCreating(false);
    }
  };

  const handleClose = () => {
    setTitle('');
    setType(NOTIFICATION_TYPES[0]);
    setMessage('');
    setCreating(false);
    onClose();
  };

  return (
    <>
    <Modal show={show && !showPreview} onHide={handleClose} size="xl" dialogClassName={styles.createModalDialog} centered className="text-black">
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Create Notification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-3">
            <Form.Label>Title <span className="text-danger">*</span></Form.Label>
            <FormControl required value={title} onChange={(e) => setTitle(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Tag</Form.Label>
            <br />
            <FormSelect className={styles.formSelect} value={type} onChange={(e) => setType(e.target.value)}>
              {NOTIFICATION_TYPES.map((t) => <option key={t} value={t}>{t}</option>)}
            </FormSelect>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Content <span className="text-danger">*</span></Form.Label>
            <RichTextEditor value={message} onChange={setMessage} placeholder="Enter message..." />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose} disabled={creating}>Cancel</Button>
          <Button variant="primary" type="submit" disabled={creating || !title || !message}>
            {creating ? 'Creating...' : 'Create Notification'}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
    <NotificationDetailModal
      show={showPreview}
      onClose={() => setShowPreview(false)}
      notification={{
        title,
        message,
        type,
        created_at: new Date().toISOString(),
        creator: (() => {
          try {
            const auth = JSON.parse(localStorage.getItem('auth') || '{}');
            const user = auth.user || {};
            return {
              first_name: user.first_name || '',
              last_name: user.last_name || '',
              email: user.email || ''
            };
          } catch (e) {
            return null;
          }
        })()
      }}
      onConfirm={handleConfirmCreate}
      confirmLabel={creating ? 'Creating...' : 'Confirm'}
    />
    </>
  );
}


